export const formatPluralizedText = (
  numberOfQuestion: number,
  textToDisplay: string,
) => {
  return `${numberOfQuestion} ${textToDisplay}${
    numberOfQuestion === 1 ? '' : 's'
  }`;
};
